module.exports = __webpack_public_path__ + "static/img/singok.71d5d65e.webp";